module.exports = __webpack_public_path__ + "static/media/verticalRectangle_black.c49e1030.svg";